/**
 * <s-trek-visuals> — trek page 3D / itinerary pop-up.
 * When a visitor opens the YouTube itinerary or 3D view (new tab) and later
 * returns to this page, it closes the pop-up and shows a reminder card
 * ([data-reminder]) with Book now and WhatsApp actions.
 */
class STrekVisuals extends HTMLElement {
  #ac;
  #pending = false;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const reminder = this.querySelector('[data-reminder]');
    const dialog = this.querySelector('dialog');

    this.querySelectorAll('[data-visual-link]').forEach((link) => {
      link.addEventListener('click', () => { this.#pending = true; }, opts);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible' || !this.#pending || !reminder) return;
      this.#pending = false;
      if (dialog?.open) dialog.close();
      reminder.hidden = false;
    }, opts);

    this.querySelector('[data-reminder-close]')?.addEventListener('click', () => {
      if (reminder) reminder.hidden = true;
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-trek-visuals')) customElements.define('s-trek-visuals', STrekVisuals);
